/** Query Params. */
export class QueryParams {
  constructor(data) {
    this.page = data.page;
    this.perPage = data.perPage;
    this.sortBy = data.sortBy;
    this.sortDirection = data.sortDirection;
    this.orderId = data.orderId;
  }
}

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

/**
 * Map table sort value to model.
 * @param {object} sort Sort.
 * @returns {object}
 */
export function mapTableSortToModel(sort) {
  return {
    sortBy: sort.length > 0 ? sort[0].key : '',
    sortDirection: sort.length && sort[0].order === 'asc'
      ? SORT_DIRECTION.ASC
      : SORT_DIRECTION.DESC,
  };
}

/**
 *  Map model to table sort value.
 * @param {object} model Sort model value.
 * @returns {object[]}
 */
export function mapModelToTableSort(model) {
  return [
    {
      key: model.sortBy,
      order: model.sortDirection === SORT_DIRECTION.ASC ? 'asc' : 'desc',
    },
  ];
}

export const DEFAULT_QUERY_PARAMS = new QueryParams({
  page: 1,
  perPage: 25,
});

export const DEFAULT_QUERY_PARAMS_WITH_SORT = new QueryParams({
  page: 1,
  perPage: 25,
  sortBy: 'createdDate',
  sortDirection: SORT_DIRECTION.DESC,
});
